import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function TickIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="13"
        viewBox="0 0 16 13"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5.6 8.125L2.4 4.875L0 7.3125L5.6 13L16 2.4375L13.6 0L5.6 8.125Z" />
      </svg>
    </Icon>
  );
}
